import { useRef, useEffect } from 'react';

const usePrevious = <T = unknown>(value: T) => {
  const ref = useRef<T>(undefined);

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export default usePrevious;
